import { render } from "./RegiteredTBTHList.vue?vue&type=template&id=7fc566fa&scoped=true"
import script from "./RegiteredTBTHList.vue?vue&type=script&lang=js"
export * from "./RegiteredTBTHList.vue?vue&type=script&lang=js"

import "./RegiteredTBTHList.vue?vue&type=style&index=0&id=7fc566fa&lang=scss&scoped=true"

import exportComponent from "/DATA/REPO/survey-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc566fa"]])

export default __exports__